import api from './axios';

export interface Message {
  id: number;
  content: string;
  created_at: string;
  updated_at: string | null;
  slack_thread_id: string | null;
  slack_channel_id: string | null;
  slack_timestamp: string | null;
  is_from_slack: boolean;
  is_read: boolean;
  sender_name?: string; // Added for Slack sender names
}

export interface MessageResponse {
  messages: Message[];
}

export interface UnreadCountResponse {
  count: number;
}

const chatService = {
  /**
   * Send a new message
   * @param content The message content
   * @returns The created message
   */
  sendMessage: async (content: string) => {
    const response = await api.post('/api/messages', { content });
    return response.data;
  },

  /**
   * Get messages for the current user
   * @param limit Maximum number of messages to retrieve
   * @param offset Offset for pagination
   * @param all Whether to fetch all messages (requires admin)
   * @returns List of messages
   */
  getMessages: async (limit = 50, offset = 0, all = false) => {
    const response = await api.get<MessageResponse>('/api/messages', {
      params: { limit, offset, all }
    });
    return response.data;
  },

  /**
   * Mark a message as read
   * @param messageId The ID of the message to mark as read
   * @returns Success indicator
   */
  markAsRead: async (messageId: number) => {
    const response = await api.put(`/api/messages/${messageId}/read`);
    return response.data;
  },

  /**
   * Get the count of unread messages
   * @returns The number of unread messages
   */
  getUnreadCount: async () => {
    const response = await api.get<UnreadCountResponse>('/api/messages/unread-count');
    return response.data;
  }
};

export default chatService;